/**
 * Nutrition page shell.
 *
 * Phase 24.4b Step 3: hosts top-level Tabs container with two tabs —
 * Today (default, renders NutritionTodayTab) and Plan (placeholder
 * stub; Step 6 replaces it with the full MealPlanContainer + siblings).
 *
 * URL state: `?tab=plan` activates the Plan tab; absent/`?tab=today`
 * keeps Today (default tab is omitted from URL per Tabs primitive
 * contract).
 */
import { useTranslation } from "react-i18next";
import { BackButton } from "@/components/ui/BackButton";
import { Tabs } from "@/components/ui/Tabs";
import NutritionTodayTab from "@/components/nutrition/NutritionTodayTab";
import NutritionPlanTab from "@/components/nutrition/NutritionPlanTab";

export default function Nutrition() {
  const { t } = useTranslation();
  return (
    <div className="mx-auto max-w-7xl space-y-5">
      <BackButton to="/" label={t("nutrition_page.back_home")} withHome={false} />
      <Tabs
        tabs={[
          { key: "today", label: t("nutrition_page.tab_today") },
          { key: "plan", label: t("nutrition_page.tab_plan") },
        ]}
        defaultTab="today"
      >
        {(activeKey) =>
          activeKey === "plan" ? <NutritionPlanTab /> : <NutritionTodayTab />
        }
      </Tabs>
    </div>
  );
}
